<template>
            <div
                class="field"
                :class="{ 'has-addons': staticRight }"
                :style="fieldStyle"
            >
                <div
                    class="control"
                    :class="{ 'has-icons-left': isMoney }"
                    :style="controlStyle"
                >
                    <template v-if="loading">
                        <span
                            :id="id"
                            class="input input-loading"
                            :class="inputClass"
                            v-bind="$attrs"
                        >&nbsp;</span>
                    </template>
                    <template v-else>
                        <input
                            v-if="type === 'text' || type === 'email' || type === 'time' || type === 'date'"
                            :type="type"
                            :placeholder="placeholder"
                            :id="id"
                            class="input"
                            :class="inputClass"
                            :value="myValue"
                            v-bind="$attrs"
                            @input="onInput"
                            :name="name"
                        >
                        <input
                            v-if="type === 'number'"
                            type="text"
                            :placeholder="placeholder"
                            :id="id"
                            class="input"
                            :class="inputClass"
                            v-bind="$attrs"
                            :value="myValue"
                            @input="onInput"
                            @change="onInput"
                            inputmode="numeric"
                            pattern="[0-9]*"
                            style="text-align: right;"
                            :name="name"
                        >
                        <input
                            v-if="type === 'checkbox'"
                            type="checkbox"
                            :id="id"
                            :class="inputClass"
                            :checked="myValue"
                            :value="value"
                            v-bind="$attrs"
                            style="margin-top: 18px"
                            @input="onInput"
                            @change="onInput"
                            :name="name"
                        >
                        <textarea
                            v-if="type === 'textarea'"
                            :placeholder="placeholder"
                            :id="id"
                            class="textarea"
                            :class="inputClass"
                            :value="myValue"
                            v-bind="$attrs"
                            @input="onInput"
                            @change="onInput"
                            :name="name"
                        ></textarea>
                        <div
                            v-if="type === 'div'"
                            :id="id"
                            class="input"
                            :class="inputClass"
                            v-bind="$attrs"
                        ></div>

                        <span class="icon is-small is-left" v-if="isMoney">
                            <i class="fas fa-dollar-sign"></i>
                        </span>
                    </template>
                </div>
                <div class="control" v-if="staticRight">
                    <a class="button is-static">{{ staticRight }}</a>
                </div>
                <p
                    class="help is-info"
                    v-if="info"
                    v-html="info"
                    style="line-height: 1;"
                />
                <p
                    class="help is-danger"
                    v-if="validator && validator.$dirty && validator.$invalid"
                >
                    {{ errorMessage }}
                </p>
            </div>
</template>

<script>
export default {
    inheritAttrs: false,
    props: {
        loading: {
            type: Boolean,
            default: false,
        },
        id: {
            type: String,
            default: '',
        },
        name: {
            type: String,
            default: '',
        },
        type: {
            type: String,
            default: 'text',
        },
        placeholder: {
            type: String,
            default: '',
        },
        isMoney: {
            type: Boolean,
            default: false,
        },
        staticRight: {
            type: String,
            default: '',
        },
        inputClass: {
            type: Array,
            default() { return []; },
        },
        value: {
            type: [Number, String, Boolean],
            default: '',
        },
        validator: {
            type: Object,
            default: null,
        },
        info: {
            type: String,
        },
        errorCond: {
            type: Boolean,
            default: true,
        },
        errorMessage: {
            type: String,
            default: '',
        },
        fieldStyle: {
            type: String,
            default: '',
        },
        controlStyle: {
            type: String,
            default: '',
        },
    },
    data() {
        return {
            myValue: this.value,
        }
    },
    watch: {
        value(cur, prev) {
            this.myValue = cur;
        },
    },
    methods: {
        onInput($event) {
            this.validator && this.validator.$touch();
            this.myValue = this.type === 'checkbox' ? $event.target.checked : $event.target.value;
            this.$emit('input', this.myValue);
        },
    }
}
</script>

<style>
.autoHeight {
    height: unset;
}
</style>
